import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, getCurrentInstance } from 'vue';

import AppDialog from '@/components/dialogs/AppDialog/AppDialog.vue';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';

interface Props {
	dialogPromiseHandlers: { resolve: () => void; reject: () => void };
	title: string;
	description: string;
	primaryButtonText: string;
	secondaryButtonText?: string;
	onPrimaryClick?: () => Promise<void>;
	onSecondaryClick?: () => Promise<void>;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RunFailInfoDialog',
  props: {
    title: null,
    description: null,
    primaryButtonText: null,
    secondaryButtonText: { default: 'Close' },
    onPrimaryClick: null,
    onSecondaryClick: null,
    dialogPromiseHandlers: null
  },
  setup(__props: any) {

const props: Props = __props as { title: string, description: string, primaryButtonText: string, secondaryButtonText: string, onPrimaryClick?: () => Promise<void>, onSecondaryClick?: () => Promise<void>, dialogPromiseHandlers: { resolve: () => void; reject: () => void } }


const showSecondaryButton = computed(() => props.onPrimaryClick || props.onSecondaryClick);
const toast = getCurrentInstance()?.proxy.$toast;
const isPrimaryLoading = ref(false);
const isSecondaryLoading = ref(false);
const onPrimary = async () => {
	if (props.onPrimaryClick) {
		try {
			isPrimaryLoading.value = true;
			await props.onPrimaryClick();
			close();
		} catch {
			toast?.error('An error occured, please try again later');
			setTimeout(() => {
				close();
			}, 1000);
		} finally {
			isPrimaryLoading.value = false;
		}
	} else {
		close();
	}
};

const onSecondary = async () => {
	if (props.onSecondaryClick) {
		try {
			isSecondaryLoading.value = true;
			await props.onSecondaryClick();
			close();
		} catch {
			toast?.error('An error occured, please try again later');
			setTimeout(() => {
				close();
			}, 1000);
		} finally {
			isSecondaryLoading.value = false;
		}
	} else {
		close();
	}
};

const close = () => {
	props.dialogPromiseHandlers.resolve();
	AppDialogManagerService.closeCurrentDialog();
};

return { __sfc: true,props, showSecondaryButton, toast, isPrimaryLoading, isSecondaryLoading, onPrimary, onSecondary, close, AppDialog }
}

})